(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-community-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mz-community-video-carousel')) {
    class MzCommunityVideoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-community-track]');
        this.cards = Array.from(this.querySelectorAll('[data-community-card]'));
        this.previousButton = this.querySelector('[data-community-previous]');
        this.nextButton = this.querySelector('[data-community-next]');
        this.currentLabel = this.querySelector('[data-community-current]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.track || !this.cards.length) return;

        this.currentIndex = 0;
        this.inViewport = false;
        this.isNavigating = false;
        this.userPaused = false;
        this.arrangeAround(this.currentIndex);
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onScroll = () => this.queueCenterUpdate();
        this.onResize = () => this.queueCenterUpdate();
        this.onVisibilityChange = () => this.handleVisibilityChange();

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.cards.forEach((card, index) => {
          const video = card.querySelector('video');
          const toggle = card.querySelector('[data-community-toggle]');
          if (!video || !toggle) return;

          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');

          toggle.addEventListener('click', () => {
            if (index !== this.currentIndex) {
              this.userPaused = false;
              this.goTo(index);
              return;
            }

            if (video.paused) {
              this.userPaused = false;
              this.playActiveVideo();
            } else {
              this.userPaused = true;
              video.pause();
            }
          });

          video.addEventListener('play', () => this.syncCard(card, video, toggle));
          video.addEventListener('pause', () => this.syncCard(card, video, toggle));
          video.addEventListener('ended', () => {
            this.syncCard(card, video, toggle);
            if (index === this.currentIndex) {
              this.userPaused = false;
              this.move(1);
            }
          });
          this.syncCard(card, video, toggle);
        });

        this.onBlockSelect = (event) => {
          const card = event.target.closest('[data-community-card]');
          const index = this.cards.indexOf(card);
          if (index < 0) return;
          this.userPaused = true;
          this.goTo(index, false);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.inViewport = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .35);
            if (this.inViewport) {
              this.playActiveVideo();
            } else {
              this.pauseAllVideos();
            }
          }, { threshold: [0, .35, .7] });
          this.visibilityObserver.observe(this);
        } else {
          this.inViewport = true;
        }

        requestAnimationFrame(() => {
          this.centerOn(this.currentIndex, 'auto');
          this.activateIndex(this.currentIndex, true);
        });
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.visibilityObserver?.disconnect();
        clearTimeout(this.centerTimer);
        clearTimeout(this.navigationTimer);
      }

      move(direction) {
        const nextIndex = (this.currentIndex + direction + this.cards.length) % this.cards.length;
        this.userPaused = false;
        this.goTo(nextIndex, true);
      }

      arrangeAround(index) {
        const cardCount = this.cards.length;
        const precedingCount = Math.floor(cardCount / 2);

        this.cards.forEach((card, cardIndex) => {
          const visualOrder = (cardIndex - index + precedingCount + cardCount) % cardCount;
          card.style.order = String(visualOrder);
        });
      }

      centerOn(index, behavior = 'auto') {
        const targetCard = this.cards[index];
        if (!targetCard) return;

        const targetLeft = targetCard.offsetLeft - ((this.track.clientWidth - targetCard.offsetWidth) / 2);
        this.track.scrollTo({
          left: Math.max(0, targetLeft),
          behavior
        });
      }

      goTo(index, autoplay = true) {
        const targetIndex = (index + this.cards.length) % this.cards.length;
        const targetCard = this.cards[targetIndex];
        if (!targetCard) return;

        this.isNavigating = true;
        this.activateIndex(targetIndex, false);

        this.centerOn(targetIndex, this.reducedMotion.matches ? 'auto' : 'smooth');

        clearTimeout(this.navigationTimer);
        this.navigationTimer = setTimeout(() => {
          this.arrangeAround(targetIndex);
          this.centerOn(targetIndex, 'auto');
          this.isNavigating = false;
          this.activateIndex(targetIndex, autoplay);
        }, this.reducedMotion.matches ? 0 : 420);
      }

      closestCenteredIndex() {
        const trackRect = this.track.getBoundingClientRect();
        const trackCenter = trackRect.left + (trackRect.width / 2);
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const distance = Math.abs((cardRect.left + (cardRect.width / 2)) - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      activateIndex(index, autoplay = true) {
        const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const changed = nextIndex !== this.currentIndex;
        this.currentIndex = nextIndex;

        this.cards.forEach((card, cardIndex) => {
          const isActive = cardIndex === nextIndex;
          const directDistance = Math.abs(cardIndex - nextIndex);
          const distanceFromActive = Math.min(directDistance, this.cards.length - directDistance);
          card.classList.toggle('is-active', isActive);
          card.classList.toggle('is-near', distanceFromActive === 1);
          card.classList.toggle('is-far', distanceFromActive > 1);
          if (isActive) {
            card.setAttribute('aria-current', 'true');
          } else {
            card.removeAttribute('aria-current');
            const video = card.querySelector('video');
            if (video) {
              video.pause();
              if (changed && video.readyState > 0) video.currentTime = 0;
            }
          }
        });

        if (changed) this.userPaused = false;
        if (this.currentLabel) this.currentLabel.textContent = String(nextIndex + 1);
        if (autoplay) this.playActiveVideo();
      }

      playActiveVideo() {
        if (!this.inViewport || document.hidden || this.userPaused) return;
        const activeCard = this.cards[this.currentIndex];
        const video = activeCard?.querySelector('video');
        const toggle = activeCard?.querySelector('[data-community-toggle]');
        if (!video || !toggle) return;

        this.pauseOtherVideos(video);
        video.muted = true;
        if (video.ended && video.readyState > 0) video.currentTime = 0;
        video.play().catch(() => this.syncCard(activeCard, video, toggle));
      }

      pauseAllVideos() {
        this.cards.forEach((card) => {
          const video = card.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.pauseAllVideos();
        } else {
          this.playActiveVideo();
        }
      }

      pauseOtherVideos(activeVideo) {
        this.cards.forEach((card) => {
          const video = card.querySelector('video');
          if (video && video !== activeVideo && !video.paused) video.pause();
        });
      }

      syncCard(card, video, toggle) {
        const isPlaying = !video.paused && !video.ended;
        card.classList.toggle('is-playing', isPlaying);
        toggle.setAttribute('aria-pressed', String(isPlaying));
        toggle.setAttribute('aria-label', isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      }

      queueCenterUpdate() {
        if (this.isNavigating) return;
        clearTimeout(this.centerTimer);
        this.centerTimer = setTimeout(() => {
          this.isNavigating = true;
          const nextIndex = this.closestCenteredIndex();
          this.activateIndex(nextIndex, true);
          this.arrangeAround(nextIndex);
          this.centerOn(nextIndex, 'auto');
          requestAnimationFrame(() => {
            this.isNavigating = false;
          });
        }, 140);
      }
    }

    customElements.define('mz-community-video-carousel', MzCommunityVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-pdp-media-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mz-media-carousel')) {
    class MzMediaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mz-track]');
        this.cards = Array.from(this.querySelectorAll('[data-mz-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-mz-dot]'));
        this.section = this.closest('.mz-media-section');
        this.previousButton = this.section && this.section.querySelector('[data-mz-prev]');
        this.nextButton = this.section && this.section.querySelector('[data-mz-next]');
        if (!this.track || !this.cards.length) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        window.addEventListener('resize', () => this.queueUpdate(), { passive: true });
        this.update();
      }

      move(direction) {
        const activeIndex = this.cards.findIndex((card) => card.classList.contains('is-active'));
        const nextIndex = Math.max(0, Math.min(this.cards.length - 1, activeIndex + direction));
        this.cards[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const trackCenter = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        let activeIndex = 0;
        let nearest = Number.POSITIVE_INFINITY;
        this.cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - trackCenter);
          if (distance < nearest) {
            nearest = distance;
            activeIndex = index;
          }
        });
        this.cards.forEach((card, index) => card.classList.toggle('is-active', index === activeIndex));
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
        if (this.previousButton) this.previousButton.disabled = activeIndex === 0;
        if (this.nextButton) this.nextButton.disabled = activeIndex === this.cards.length - 1;
      }
    }

    customElements.define('mz-media-carousel', MzMediaCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
